// 引入组件
import headComponent from "components/content/Head";	// header
import footComponent from "components/content/Foot";	// footer
import footComponent1 from "components/content/Foot1";	// footer


export default {
	headComponent,
  	footComponent,
  	footComponent1
}
